<template>
  <div class="selector">

    <div class="selector__content form__field flex justify-between items-center">
      <div class="form__label">
        <h3 class="selector__title">Color</h3>
        <p class="selector__help-text">Color select</p>
      </div>
      <v-swatches v-model="color"
                  @input="setColor"
                  row-length="5"
                  shapes="circles"
                  show-border
                  popover-x="left"
                  show-fallback
                  fallback-input-type="color"
                  class="selector__input"></v-swatches>
    </div>
  </div>
</template>

<script>
  import VSwatches from 'vue-swatches'

  import { mapGetters, mapActions, mapMutations } from 'vuex';
  import * as mutationTypes from '../../store/mutation-types'

  export default {
    name: "FabricColorSelector",
    components: {
      VSwatches
    },
    data() {
      return {
        color: '#ffffff',
      }
    },
    computed: {
      ...mapGetters('clothes',[
        'selectedMesh',
      ]),
      ...mapGetters('textures',[
        'selectedTexture',
        'selectedColor',
        'colors',
      ]),
    },
    watch: {
      selectedMesh: function() {
        if(this.selectedColor) {
          this.color = this.selectedColor;
        }
        // this.color = '#'+this.selectedMesh.material.color.getHexString();
        // this.updateLocalColor(this.selectedMesh.userData.color);
      },
      selectedColor: function() {
        this.color = this.selectedColor;
      }
    },
    methods: {
      ...mapActions('clothes',[
        'setMeshColor'
      ]),
      ...mapActions('textures',[
        'setSelectedColor'
      ]),
      ...mapActions([
        'render'
      ]),
      ...mapMutations('textures',[
        mutationTypes.SET_SELECTED_COLOR,
      ]),
      setColor(color) {

        // console.log(color);
        // console.log(this.selectedMesh);
        this.setMeshColor(color).then(() => {
          //this.setSelectedColor(color);
          this.render();
        });
      },
      // updateLocalColor(threeColor) {
      //   if(threeColor) {
      //     // this[mutationTypes.SET_SELECTED_COLOR](this.selectedMesh.userData.color.getHex());
      //     this.setSelectedColor('#'+threeColor.getHexString());
      //     this.color = '#'+threeColor.getHexString();
      //   } else {
      //     this.color = '';
      //   }
      // }
    },
    mounted() {
      if(this.selectedColor) {
        this.color = this.selectedColor;
        // console.log(this.selectedMesh.material.color);
      }
    }
  }
</script>

<style scoped>

</style>